export interface Category {
  slug: string;
  nameKey: string;
  icon: string;
}

export const categories: Category[] = [
  { slug: "platform", nameKey: "category.platform", icon: "ri-computer-line" },
  { slug: "membership", nameKey: "category.membership", icon: "ri-vip-crown-line" },
  { slug: "promotions", nameKey: "category.promotions", icon: "ri-coupon-line" },
  { slug: "security", nameKey: "category.security", icon: "ri-shield-star-line" },
];

export interface CategoryArticle {
  id: number;
  title: string;
  summary: string;
  category: string;
  date: string;
  readTime: string;
}

export const categoryArticles: CategoryArticle[] = [
  // 平台介绍
  { id: 1, title: "必赢国际平台全方位介绍", summary: "深入了解必赢国际的发展历程、核心业务模式以及全球化战略布局，为您呈现一个真实、全面的国际平台。", category: "platform", date: "2026-07-28", readTime: "8分钟" },
  { id: 2, title: "平台操作指南：快速上手必赢国际", summary: "从注册到使用，手把手教您掌握必赢国际平台的全部功能，让您轻松开启精彩旅程。", category: "platform", date: "2026-07-25", readTime: "6分钟" },
  { id: 3, title: "必赢国际全球化发展战略解读", summary: "探索必赢国际在全球市场的布局策略、合作伙伴网络以及未来发展规划，见证国际化平台的崛起。", category: "platform", date: "2026-07-20", readTime: "10分钟" },
  { id: 4, title: "为什么选择必赢国际：五大核心价值", summary: "安全、公正、多元、高效、贴心——五大核心价值观铸就必赢国际的行业领先地位。", category: "platform", date: "2026-07-15", readTime: "7分钟" },

  // 会员权益
  { id: 5, title: "必赢国际会员等级体系详解", summary: "全面解析青铜到钻石五大会员等级，了解每一级的专属权益与升级条件，规划您的成长路径。", category: "membership", date: "2026-07-30", readTime: "9分钟" },
  { id: 6, title: "VIP会员专属福利大揭秘", summary: "高级会员享有哪些隐藏福利？本文为您一一揭晓铂金及钻石会员的独家权益与尊贵体验。", category: "membership", date: "2026-07-26", readTime: "7分钟" },
  { id: 7, title: "如何快速提升会员等级", summary: "分享高效提升会员等级的策略与技巧，帮助您在更短时间内解锁更多专属权益。", category: "membership", date: "2026-07-22", readTime: "5分钟" },
  { id: 8, title: "会员积分获取与使用全攻略", summary: "积分是必赢国际会员的重要资产，本文详细说明积分的获取途径、兑换规则及最大化价值的方法。", category: "membership", date: "2026-07-18", readTime: "6分钟" },

  // 优惠活动
  { id: 9, title: "八月盛夏狂欢：限时优惠活动汇总", summary: "必赢国际八月推出多重优惠活动，涵盖首存礼包、充值返利、签到奖励等，超值福利不容错过。", category: "promotions", date: "2026-08-01", readTime: "5分钟" },
  { id: 10, title: "新会员专属：首存100%加赠攻略", summary: "详细解读新会员首存加赠活动的参与条件、奖励规则以及最优策略，让您的新手福利最大化。", category: "promotions", date: "2026-07-29", readTime: "6分钟" },
  { id: 11, title: "周末特惠：限时双倍返利活动", summary: "每周末推出双倍返利活动，参与简单、奖励丰厚，是快速积累积分的最佳时机。", category: "promotions", date: "2026-07-27", readTime: "4分钟" },
  { id: 12, title: "节日专属福利日历", summary: "盘点必赢国际全年节日福利安排，不错过任何一个领取专属好礼的机会。", category: "promotions", date: "2026-07-23", readTime: "8分钟" },

  // 安全保障
  { id: 13, title: "必赢国际安全体系全面解读", summary: "从数据加密到资金托管，从身份验证到风控系统，全方位了解必赢国际的安全保障体系。", category: "security", date: "2026-07-31", readTime: "10分钟" },
  { id: 14, title: "数据隐私保护：您的信息如何被守护", summary: "必赢国际严格遵守国际数据保护法规，采用银行级加密技术，确保每位用户的隐私安全。", category: "security", date: "2026-07-24", readTime: "7分钟" },
  { id: 15, title: "公平公正：国际认证与监管", summary: "必赢国际获得多项国际权威机构认证，所有服务流程接受独立第三方监管，确保公平透明。", category: "security", date: "2026-07-19", readTime: "8分钟" },
  { id: 16, title: "账户安全防护指南", summary: "为您提供实用的账户安全防护建议，包括密码管理、二次验证设置以及异常登录检测。", category: "security", date: "2026-07-16", readTime: "5分钟" },
];